<template>
  <el-scrollbar style="height:100%" class="el-menu-scrollbar__wrap" v-if="Visible">
    <el-tree
      :data="treeData"
      :props="props"
      :load="loadNode"
      lazy
      :key="treekey"
      :show-checkbox="isCheck || (isdoorMultiple && !onlyuser && !radio)"
      :check-on-click-leaf="!isCheck"
      node-key="roleId"
      highlight-current
      check-strictly
      ref="tree"
      :default-checked-keys="checkedKeys"
      @check-change="handleCheckChange"
      @current-change="handleCurrentChange"
      :expand-on-click-node="false">
      <template #default="{ node }">
        <span class="custom-tree-node ellipsis">
          <span>{{ node.label }}</span>
        </span>
      </template>
    </el-tree>
  </el-scrollbar>
  
</template>

<script>
import { getopenrolelist, getapirolelist } from '@/port/clientSide/multipleChoice'
export default {
  name: 'roleChoice',
  data () {
    return {
      Visible: false,
      props: {
          label: 'name',
          children: 'children',
          isLeaf: 'leaf'
        },
      apiUrl: false, //默认为客户端 true为服务端
      option: null, // 有选项，就不走接口
      onlyuser: false, //之选用户
      leaf: false, // true不能有下级
      checkedKeys:[],// 默认选择的，勾选使用
      checkedArr: [], //选中的数据
      pargam: {},
      selfrole:1,//所在角色
      radio:false,
      treeData:[],
      node_had:null,
      resolve_had:null,
      isSpace: false, // 是否从空间进入
      spaceId: null, //空间角色id
      upaceId: null, //空间角色id
      isdoorMultiple: true, // 门户控制单选多选
    }
  },
  props: {
    isUserSpace: {
      type: Boolean,
    },
    treekey: {
      type:Number
    },
    userSelect: {
      type: String,
      default:'platform'
    },
    maxCount: {
      type: Number,
      default: 0
    },
    isCheck: {
      type: Boolean,
      default: false
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  methods: {
    fromParent(pargam,setting){
     [...setting.checkedArr].forEach(element => {
        this.checkedKeys.push(element.roleId)
     });
      console.log(pargam,setting,'pargam,setting');
      
      this.apiUrl = setting.apiurl
      this.checkedArr = setting.checkedArr
      this.onlyuser = setting.onlyUser || false
      this.option = setting.option && typeof setting.option == "string" ? JSON.parse(setting.option) : setting.option
      this.radio = setting.radio
      this.leaf = setting.leaf || false
      this.isdoorMultiple = setting.isdoorMultiple === undefined ? true : setting.isdoorMultiple
      this.pargam = pargam || {}
      this.Visible = true
    },
    async fromParentSearch (val,isSpace) {
      if (val) {
        // this.$refs.tree.$data.store.lazy = !val//搜索内容filterText不为空的话，懒加载模式为false
        let obj = {curpage: 0, pagesize: 0,role:1}
        obj.name = val
        // 空间角色选项卡内搜索
        if(this.spaceId !== null){
          obj.spaceid = this.spaceId
        }
        else if(this.upaceId !== null){
          obj.upaceid = this.upaceId
        }
        if (isSpace === 'space') {
          obj.spaceid = this.$route.query.spaceid
        } else if (isSpace === 'upace') {
          obj.upaceid = this.$route.query.upaceid
        } else if(isSpace === 'platform'){
          delete obj.spaceid
          delete obj.upaceid
        }
        const res = await this.ongetlist(obj)//调用后台搜索接口
        if (res.length) {
          this.treeData = res
          // 默认展开节点
        } else {
          this.treeData = []
        }
      } else {
        // this.$refs.tree.$data.store.lazy = true
        this.spaceId = null
        this.upaceid = null
        this.treeData = []
        this.loadNode(this.node_had,this.resolve_had)
      }      
      this.checkedKeys = []
      this.checkedArr.forEach(item =>{
        this.checkedKeys.push(item.roleId)
      })
    },
    async loadNode (node, resolve) {
      if(this.option&&node.level === 0){
        let orglist = this.roleRes(this.option)
        this.node_had = node
        this.resolve_had = resolve
        return resolve(orglist)
      }
      let obj = {
          pid: node.data && node.data.roleId ? node.data.roleId : 0,
          curpage: 0,
          pagesize: 0
      };
      if (this.isUserSpace) {
        if (this.userSelect === 'space') {
          const spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
          obj.spaceid = spaceid
        } else if (this.userSelect === 'upace') {
          const upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
          obj.upaceid = upaceid
        } else {
          delete obj.spaceid
          delete obj.upaceid
        }
      }
      // 空间角色选项卡点击加载子级
      if(this.spaceId !== null){
        obj.spaceid = this.spaceId
      }
      else if(this.upaceId !== null){
        obj.upaceid = this.upaceId
      }
      if (node.level===0) { // 初始化
        Object.assign(obj, this.pargam); // 两个对象合并
      }
      let resData = await this.ongetlist(obj,node.level === 0)
      if (node.level === 0) {
        this.node_had = node
        this.resolve_had = resolve
        return resolve(resData);
      }
      resolve(resData)
    },
    reloadNode() {
      // 手动调用 loadNode 方法来重新加载节点数据
      this.node_had.childNodes = [];
      this.loadNode(this.node_had, this.resolve_had);
    },
    // 获取空间角色数据
    async getspaceRole(val){
      let obj = {pid: 0, curpage: 0, pagesize: 0}
      // this.$refs.tree.$data.store.lazy = true
      this.spaceId = val
      obj.spaceid = val
      const res = await this.ongetlist(obj, true)//调用后台搜索接口
      if (res.length) {
        this.treeData = res
        // 默认展开节点
      } else {
        this.treeData = []
      }
    },
    // 清空角色数据
    clearspaceRole(){
      this.treeData = []
    },
    ongetlist(obj,disabled){
      let that = this
      return new Promise(function (resolve) {
        // 从空间进入，需要传空间id
        if(that.isSpace){
          let spaceId = typeof(that.$route.query.spaceid) !== 'undefined' ? that.$route.query.spaceid : localStorage.getItem('spaceid')
          obj.spaceid = spaceId;
        }
        else if (that.isUpace) {
          let upaceId = typeof(that.$route.query.upaceid) !== 'undefined' ? that.$route.query.upaceid : localStorage.getItem('upaceid')
          obj.upaceid = upaceId
        }
        if (that.apiUrl) {
          getapirolelist(obj).then(res => {
            let rolelist = that.roleRes(res.data||[], disabled)
            resolve(rolelist)
          }).catch(err => {
            console.log('组织获取错误', err)
          })
        } else {
          getopenrolelist(obj).then(res => {
            let rolelist = that.roleRes(res.data||[], disabled)
            if (that.pargam.selfrole && that.pargam.selfrole===1) {
              // 如果这个等于1，那么就是当前角色，那么需要吧当前的参数回传回去，放到option里面，给用户搜索使用
              that.$emit('handleSelect', 2, rolelist)
            }
            resolve(rolelist)
          }).catch(err => {
            console.log('组织获取错误', err)
          })
        }
      })
    },
    roleRes (data,disabled) {
      return data.map(item => {
        return this.leaf ? {...item, leaf: true, disabled: disabled} : {...item, disabled: disabled}
      })
    },
    // 当前节点选择发生改变时候
    handleCheckChange(data, checked){
      if (checked) { 
        let CheckedKeys = this.$refs.tree.getCheckedKeys()
        // 超过最大可选择数量时，删除roleId对应的值
        if(this.maxCount !== 0 && this.maxCount !== null && CheckedKeys.length > this.maxCount){
          CheckedKeys = CheckedKeys.filter(item => item !== data.roleId);
          this.$refs.tree.setCheckedKeys(CheckedKeys)
          this.$message.error('最多只能选择' + this.maxCount + '个角色');
          return false
        }
        this.checkedArr.push(data)
      } else {
        let index = this.checkedArr.findIndex(item =>{
          return item.roleId===data.roleId
        })
        if(index >= 0){
          this.checkedArr.splice(index,1)
        }
      }
      this.$emit('change-checked', this.checkedArr)
    },
    // 点击当前节点
    handleCurrentChange(node) {
      this.$emit('change-checked', [node])
      if (node.pid || this.option) {
        if (this.radio && !this.onlyuser) {
          this.checkedArr.splice(0,this.checkedArr.length,node)
        } else {
          this.$emit('handleSelect', 1, {curpage: 1, pagesize: 100, roleId: node.roleId})
        }
      }
    },
    // 设置打勾的节点
    setCheckedNodes(node){
      let CheckedKeys = this.$refs.tree.getCheckedKeys()
      let CheckedIndex = CheckedKeys.findIndex(item =>{
        return item === node.roleId
      })
      if (CheckedIndex > -1) { //展开过的
        CheckedKeys.splice(CheckedIndex,1)
        this.$refs.tree.setCheckedKeys(CheckedKeys)
      } else {
        this.checkedKeys.splice(this.checkedKeys.indexOf(node.roleId),1)
        this.handleCheckChange(node,false)
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    resetChecked() {
      this.checkedArr.splice(0,this.checkedArr.length)
      this.$refs.tree.setCheckedKeys([]);
    }
  },
	mounted() {

	}
}
</script>
<style lang="scss" scoped>
</style>
